// extracted by mini-css-extract-plugin
module.exports = {"messageStyle":"_12axLGEAMVy-zdANJ9FAkU"};